/**
 * AddressCorrectionFilters - Filter controls for address correction review
 *
 * SESSION 197: Address Correction Frontend Admin UI
 * SESSION_352: Updated to use responsive Grid layout for better width utilization
 *
 * Provides status filter for address correction requests
 */
import React from 'react';
import { Grid, Select, Button, Group } from '@mantine/core';
import { IconFilterOff } from '@tabler/icons-react';
import type { AddressCorrectionFiltersProps } from './AddressCorrectionReviewSection.types';

/**
 * Status filter options
 */
const STATUS_OPTIONS = [
  { value: 'Pending', label: 'Pending' },
  { value: 'Approved', label: 'Approved' },
  { value: 'Rejected', label: 'Rejected' },
  { value: 'All', label: 'All' }
];

/**
 * AddressCorrectionFilters Component
 *
 * Filter controls for address correction review workflow.
 * SESSION_352: Uses responsive Grid for better width distribution.
 */
export const AddressCorrectionFilters: React.FC<AddressCorrectionFiltersProps> = ({
  status,
  onStatusChange,
  onClearFilters
}): React.ReactElement => {
  const handleStatusChange = (value: string | null): void => {
    if (value) {
      onStatusChange(value as typeof status);
    }
  };

  return (
    <Grid gutter="md" align="flex-end">
      {/* SESSION_352: Span 6 cols (50%) to match visual weight of Aliases tab's two filters */}
      <Grid.Col span={{ base: 12, sm: 6 }}>
        <Select
          label="Status"
          placeholder="Filter by status"
          data={STATUS_OPTIONS}
          value={status}
          onChange={handleStatusChange}
          clearable={false}
        />
      </Grid.Col>

      <Grid.Col span={{ base: 12, sm: 'auto' }}>
        <Group justify="flex-start">
          <Button
            variant="subtle"
            color="gray"
            leftSection={<IconFilterOff size={16} />}
            onClick={onClearFilters}
          >
            Clear Filters
          </Button>
        </Group>
      </Grid.Col>
    </Grid>
  );
};
